import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IUsers } from "./routeType";
import { useGetAllUser } from "./getAll";
import { useGetUser } from "./get";

import { useGetAllMembers } from "@/api/members/getAll";

const { getPath } = getApi("users.activate.post");

type IExtractedRouteType = IUsers["userSingleActivate"];

export type IActivateUsers = IPickMutation<IExtractedRouteType>;

const activateUser: MutationFunction<
  IActivateUsers["response"],
  IActivateUsers["variables"]
> = ({ userId, ...data }) => {
  return axiosClient.post(getPath({ userId }), data);
};

export const useActivateUser = createMutation({
  mutationFn: activateUser,
  onSuccess: (_, { userId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
    queryClient.invalidateQueries({ queryKey: useGetAllMembers.getKey() });
    queryClient.invalidateQueries({
      queryKey: useGetUser.getKey({ userId }),
    });
  },
});
